import styled from '@emotion/styled'

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto 40px;
`
